import React from 'react';
import styles from './styles.module.css';
import LsqProgressSpinner from '../../LsqProgressSpinner';
import { BuilderDataProvider } from '../../../hooks/BuilderDataContext';

export default function ParentWrapper({
  children,
  className = '',
  loading = false,
  isBuilder,
  showBuilderBg,
  style = {}
}) {
  const content = (
    <div
      style={{ borderRadius: 8, ...style }}
      className={`${styles['parent-wrapper']} ${(isBuilder || showBuilderBg) && styles['builder-wrapper']}  ${className}`}>
      {loading && (
        <div
          className="flex align-items-center justify-content-center absolute w-full h-full z-5"
          style={{ background: 'rgba(var(--ng-neutral-white), 0.6)' }}>
          <LsqProgressSpinner />
        </div>
      )}
      {children}
    </div>
  );

  // Builder pages get BuilderDataContext automatically — BuilderTopBar reads
  // name / updateName from it without any prop drilling.
  if (isBuilder) {
    return <BuilderDataProvider>{content}</BuilderDataProvider>;
  }

  return content;
}

export const Content = ({ className, ...props }) => {
  return <div className={`${className} ${styles.content}`} {...props}></div>;
};

export const LayoutWrapper = ({ children, className = '' }) => {
  return <div className={`${styles['parent-wrapper']} ${className}`}>{children}</div>;
};
